<script setup lang="ts"></script>

<template>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <slot name="header" />
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.table {
  margin: 0;
}

.table ::v-deep(th) {
  vertical-align: middle;
  font-weight: bold;
  padding-top: 0;
}

.table ::v-deep(td) {
  vertical-align: middle;
}
</style>
